import Validation from "@/classes/global/Validation";

export default class ValidatedField {
    constructor(modelName = '', validate = false, compulsory = false, name = '', addressType = '') {

        this.modelName = modelName;
        this.validate = validate;
        this.compulsory = compulsory;
        this.name = name;
        this.addressType = addressType;
        this.trigger = new Validation();

    }
}
